import { enterAction } from '../lib/composer_enter.js'

// Auto-expanding textarea hook
const AutoExpandTextarea = {
  mounted () {
    this.adjustHeight()

    // Focus the textarea after a short delay to work around sandboxed iframe restrictions
    // The autofocus attribute may be blocked in cross-origin iframes, so we use JS as fallback
    setTimeout(() => {
      this.el.focus()
    }, 100)

    this.el.addEventListener('input', () => {
      this.adjustHeight()
    })

    // Reset on form submit
    this.el.form?.addEventListener('submit', () => {
      setTimeout(() => {
        this.el.value = ''
        this.adjustHeight()
        this.el.focus()
      }, 0)
    })

    // Enter submits; Shift/Alt+Enter and an open ``` fence add a line;
    // Ctrl/Cmd+Enter always submits; a composing IME keeps Enter.
    this.el.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') { return }
      const action = enterAction({
        isComposing: e.isComposing || e.keyCode === 229,
        shiftKey: e.shiftKey,
        altKey: e.altKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey
      }, this.el.value.slice(0, this.el.selectionStart))
      if (action === 'send') {
        e.preventDefault()
        this.el.form?.requestSubmit()
      } else if (action === 'insertNewline') {
        // Alt+Enter adds nothing by default in a textarea. insertText keeps
        // native undo and fires input; fall back to setRangeText if refused.
        e.preventDefault()
        if (!document.execCommand('insertText', false, '\n')) {
          this.el.setRangeText('\n', this.el.selectionStart, this.el.selectionEnd, 'end')
          this.el.dispatchEvent(new Event('input', { bubbles: true }))
        }
      }
    })

    // Listen for focus event from server
    this.handleEvent('focus_input', () => {
      this.el.focus()
    })
  },

  updated () {
    this.adjustHeight()
  },

  adjustHeight () {
    // Reset height to recalculate
    this.el.style.height = 'auto'

    // Set height based on content, with min and max
    const maxHeight = 200 // ~10 rows
    const newHeight = Math.min(this.el.scrollHeight, maxHeight)

    this.el.style.height = newHeight + 'px'
    this.el.style.overflowY = newHeight >= maxHeight ? 'auto' : 'hidden'
  }
}

export default AutoExpandTextarea
